import template from './group-invoice.html';
import controller from './group-invoice.controller';

let groupInvoiceComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default groupInvoiceComponent;
